export var ColorHEX;
(function (ColorHEX) {
    ColorHEX["black"] = "#000000";
    ColorHEX["white"] = "#FFFFFF";
    ColorHEX["almostWhite"] = "#F1F1F1";
    ColorHEX["lightGrey"] = "#2E3339";
    ColorHEX["mediumGrey"] = "#2C2F33";
    ColorHEX["darkGrey"] = "#1F2126";
    ColorHEX["darkerGrey"] = "#141519";
})(ColorHEX || (ColorHEX = {}));
export var PrimaryRapidColorHEX;
(function (PrimaryRapidColorHEX) {
    PrimaryRapidColorHEX["blue"] = "#0eafe2";
    PrimaryRapidColorHEX["purple"] = "#654df9";
})(PrimaryRapidColorHEX || (PrimaryRapidColorHEX = {}));
export var SecondaryRapidColorHEX;
(function (SecondaryRapidColorHEX) {
    SecondaryRapidColorHEX["orange"] = "#ff6d52";
    SecondaryRapidColorHEX["teal"] = "#08c3a5";
})(SecondaryRapidColorHEX || (SecondaryRapidColorHEX = {}));
export var NeutralRapidColorHEX;
(function (NeutralRapidColorHEX) {
    NeutralRapidColorHEX["grey"] = "#7c909b";
})(NeutralRapidColorHEX || (NeutralRapidColorHEX = {}));
// TODO: Decide naming on these colors below
export var RapidColorHEX;
(function (RapidColorHEX) {
    RapidColorHEX["chartPink"] = "#fb8176";
    RapidColorHEX["longGreen"] = "#7acc79";
    RapidColorHEX["shortPink"] = "#f14376";
    RapidColorHEX["warningYellow"] = "#fcb35f";
    RapidColorHEX["green"] = "#44c14c";
    RapidColorHEX["lightGreen"] = "#69cd70";
    RapidColorHEX["red"] = "#ef4d28";
    RapidColorHEX["lightRed"] = "#ee6588";
    RapidColorHEX["dodgerBlue"] = "#33a9ff";
    RapidColorHEX["lightDodgerBlue"] = "#5cbaff";
    RapidColorHEX["violet"] = "#9b1e74";
    RapidColorHEX["lightViolet"] = "#b528af";
    RapidColorHEX["white"] = "#f9f9f9";
    RapidColorHEX["silver"] = "#c1c1c1";
    RapidColorHEX["salomie"] = "#ffdf94";
    RapidColorHEX["lightSalomie"] = "#ccb276";
    RapidColorHEX["melon"] = "#ffbbb2";
    RapidColorHEX["lightMelon"] = "#cc968e";
    RapidColorHEX["portage"] = "#8a99f5";
    RapidColorHEX["lightPortage"] = "#adb8f8";
    RapidColorHEX["ice"] = "#97f4eb";
    RapidColorHEX["lightIce"] = "#6befe2";
})(RapidColorHEX || (RapidColorHEX = {}));
